// utils
import React from "react";
import { useMatch } from "react-router-dom";

// custom utils
import { getCurrentLanguage, LANGUAGES } from "../../utils/langUtils";

// translations
import translation_cs from "./lang/cs.json";
import translation_en from "./lang/en.json";
import translation_de from "./lang/de.json";

/**
 * BtnBgLemonWorkPosition component
 * contains BtnBgLemonWorkPosition component 
 * @returns HTML element BtnBgLemonWorkPosition component
 */
export default function BtnBgLemonWorkPosition(props:{onClick:()=>void})  {
    
    const match = useMatch("/:lang/*");
    let lang = (match && match.params.lang) ? match.params.lang : "";

    let translation = translation_cs;
    let language = getCurrentLanguage(lang);
    switch (language) {
        case LANGUAGES.Czech:
            translation = translation_cs;
            break;
        case LANGUAGES.English:
            translation = translation_en;
            break;
        case LANGUAGES.German:
            translation = translation_de;
            break;
    }

    // solves broken layout of some pages in build
    const [hasMounted, setHasMounted] = React.useState(false);
    React.useEffect(() => {
      setHasMounted(true);
    }, []);
    if (!hasMounted) {
      return null;
    }

    return (
        <>
            {/*<a className="button-wo-border bg-divelit-lemon paragraph-small" onClick={props.onClick}>{translation.btn.send}<img className="button-arrow"></img></a>*/}
            <a href={"#form_section"} className="button paragraph-medium btn-know-more-listener mt-2 mt-md-3 mb-md-4 " onClick={props.onClick}>{translation.btn.learn_more}<img className="button-arrow"></img></a>
        </>
    );
}
